import { render } from "./AddUser.vue?vue&type=template&id=38a31829&ts=true"
import script from "./AddUser.vue?vue&type=script&lang=ts"
export * from "./AddUser.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__